import { calendarApiClient, connectV1Client } from './BaseRepository';

export function getCalendarSandboxEmail(emailId) {
  return calendarApiClient.get(`api/v1/emails/${emailId}`);
}

export function getCalendarInviteData(conversationId) {
  return connectV1Client.get(`invite/conversations/${conversationId}`);
}
